module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.link) ? _c('router-link', {
    staticClass: "button",
    class: {
      'button_disabled': _vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled,
      "to": _vm.to,
      "event": !_vm.disabled ? 'click' : ''
    },
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._t("default")], 2) : _c('button', {
    staticClass: "button",
    class: {
      'button_disabled': _vm.disabled
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ccf7b48","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/info/components/button/Button.vue
// module id = ae6cfd3e7d8c369f67ae
// module chunks = 89